/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Images/ActiveTab/Images/Content/Content/Content/Comparison/Content/Content/Sections/Section/Content/PreviewImage/Content"
  
}) {
let resourceObjectMetaPreviewUrlValueData = fromData.useDataValue({ viewPath,
context: 'resource_object_meta',
path: 'preview_url',
})
let imagesComparisonSectionsOrientationValueData = fromData.useDataValue({ viewPath,
context: 'images_comparison_sections',
path: 'orientation',
})
let constantData = 'vertical'
let aggregateData = fromAggregate.equals(imagesComparisonSectionsOrientationValueData, constantData)
  return (<React.Fragment
>
<img
  data-testid="Content.Image"
  data-view-path={viewPath}
 alt={""}
 src={resourceObjectMetaPreviewUrlValueData}
 style={{'--mh-1-Z1Yf8zk': aggregateData ? "calc(50vh - 120px)" : "calc(100vh - 210px)"}}
 className={`views-block ${styles.Image}`}
/>
{children}
</React.Fragment>)
}